import InputType from "common/form/InputType";
import { Form, Input } from "decorator-form";

@Form({title: "Organization User List Config"})
export default class Config {

	@Input({type: InputType.TEXT, title: "Widget Title"})
	public flaggedTitle: string = "Most Flagged Users";
	
	
    @Input({type: InputType.TEXT, title: "Widget text"})
    public flaggedText: string = "flagged post(s)";
}



// WEBPACK FOOTER //
// ./src/panels/organizations/admin/discussion/Config.ts